<!--
 * @Author: your name
 * @Date: 2021-02-23 17:14:07
 * @LastEditTime: 2021-02-24 14:03:05
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \xy_project\src\components\ReasonDialog.vue
-->
<template>
  <div id='reasonDialog'>
    <el-dialog :visible.sync="submitVisible" width="20%" custom-class="submitVisible" @close="closeDialog" :show-close="false" top="40vh">
      <el-row>
        <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1" class="tips">*</el-col>
        <el-col :xs="23" :sm="23" :md="23" :lg="23" :xl="23">
          <el-input type="textarea" placeholder="请填写此次申请修改的内容及原因" v-model="remark"></el-input>
        </el-col>
      </el-row>
      <p v-if="fileFlag==1" class="fileReason">请填写此次申请修改的原因</p>
      <span slot="footer" class="dialog-footer">
        <span class="button add" type="primary" @click="sureSubmit">提 交</span>
        <span class="button" type="primary" @click="submitVisible=false">取 消</span>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      submitVisible: false,
      fileFlag: 0,
      remark: ''
    }
  },
  created() { },
  methods: {
    sureSubmit() {
      if (this.remark == '' || this.remark == null) {
        this.fileFlag = 1
      } else {
        if (this.$parent.name == 'Questionnaire') {
          this.$parent.situationForm.remark = this.remark
          this.$parent.commonQuesInfo()
        } else if (this.$parent.name == 'FileManagement') {
          this.$parent.fileParams.remark = this.remark
          this.$parent.comSubmit()
        }
      }
    },
    closeDialog() {
      this.fileFlag = 0
      this.remark = ''
    },
  }
}
</script>
<style lang='less' scoped>
#reasonDialog {
  /deep/.submitVisible {
    .el-dialog__header {
      border: none;
    }
    .el-dialog__body {
      padding: 0 30px 20px;
    }
    .el-textarea__inner {
      min-height: 80px !important;
      width: 100%;
      background: #fff;
    }
    .tips {
      color: #f56c6c;
    }
    .fileReason {
      margin: 10px 0 0 12px;
      color: #f56c6c;
      font-size: 12px;
    }
  }
}
</style>